import React, { Component } from "react"
import { bindActionCreators } from "redux"
import { connect } from "react-redux"
import Title from "../general/title"
import _ from "lodash"
import fieldStatus from "helpers/fieldStatus"
import submitData from "helpers/submitData"
import { toast } from "react-toastify"
import { Formik, Field, Form } from "formik"
import ReactSelect from "components/ReactSelect"
import DateField from "components/DateField"
import NumberField from "components/NumberField"
import helpers from "helpers/helpers"
import Modal from "react-responsive-modal"
import * as Yup from "yup"
import transformOptionsObject from "helpers/transformOptionsObject"
import settings from "settings"
import TextArea from "components/TextArea"
import CoPilotTexting from "components/CoPilotTexting"
import currentUser from "helpers/currentUser"

class InfoCenter extends Component {
	constructor(props) {
		super(props)
		this.user = currentUser()
		this.regularFields = {
			prospect_count: null,
			realtor_count: null,
			traffic_date: 0,
		}
		this.eventFields = {
			prospect_count: null,
			realtor_count: null,
			traffic_date: 0,
			description: "",
		}
		this.detailedFields = {
			email: "",
			zip: "",
			first_name: "",
			last_name: "",
			source: "",
			phone: "",
			traffic_date: "",
			is_realtor: 0,
			realtor: null,
			no_first: false,
			no_last: false,
			no_email: false,
			want_contact: 1,
			city: "",
			state: "",
			street: "",
			how_much: "",
			timeframe: "",
			host: "",
			notes: "",
		}
		this.webLeadsFields = {
			email: "",
			first_name: "",
			last_name: "",
			date: "",
			message: "",
			phone: "",
			zip: "",
		}
		this.state = {
			fields: _.clone(this.regularFields),
			eventField: _.clone(this.eventFields),
			detailedFields: _.clone(this.detailedFields),
			webLeadFields: _.clone(this.webLeadsFields),
			texting: false,
		}
	}

	regularValidation = () => {
		if (this.props.super) {
			return Yup.object().shape({})
		} else {
			return Yup.object().shape({
				prospect_count: Yup.number().typeError("Please enter a number.").required("Required"),
				realtor_count: Yup.number().typeError("Please enter a number.").required("Required"),
				traffic_date: Yup.number()
					.moreThan(0, "Please enter a date.")
					.required("Required")
					.typeError("Please enter a value."),
			})
		}
	}

	eventValidation = () => {
		if (this.props.super) {
			return Yup.object().shape({})
		} else {
			return Yup.object().shape({
				prospect_count: Yup.number().typeError("Please enter a number.").required("Required"),
				realtor_count: Yup.number().typeError("Please enter a number.").required("Required"),
				traffic_date: Yup.number()
					.moreThan(0, "Please enter a date.")
					.required("Required")
					.typeError("Please enter a value."),
			})
		}
	}

	detailedValidation = () => {
		return Yup.object().shape({
			source: Yup.string().notRequired(),
			email: Yup.string().email("Invalid email address").required(),
			zip: Yup.string().min(5, "Must be 5 characters").max(5, "Must be 5 characters").notRequired(),
			first_name: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			last_name: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			is_realtor: Yup.number().required("Required"),
			want_contact: Yup.number().required("Required"),
			traffic_date: Yup.number()
				.moreThan(0, "Please enter a date.")
				.required("Required")
				.typeError("Please enter a value."),
			/* realtor: Yup.string().when("is_realtor", {
				is: 1,
				then: Yup.string()
					.min(2, "Must be longer than 3 characters")
					.typeError("Please enter a valid license number.")
					.required("Required"),
				otherwise: Yup.string().nullable().notRequired(),
			}), */
		})
	}

	webLeadsValidation = () => {
		return Yup.object().shape({
			email: Yup.string().email("Invalid email address").required(),
			first_name: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			last_name: Yup.string().min(2, "Must be longer than 2 characters").required("Required"),
			date: Yup.number()
				.moreThan(0, "Please enter a date.")
				.required("Required")
				.typeError("Please enter a value."),
		})
	}

	sourceOptions = () => {
		let opts = this.props.payload.public.trafficSources
		opts = _.filter(opts, (v) => v.info_center === 1)
		return transformOptionsObject(opts)
	}

	regularLayout = (f) => {
		return (
			<div>
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("traffic_date", f)}>
							<label htmlFor="traffic_date">
								Traffic Date <sup>*</sup>
							</label>
							{f.errors.traffic_date && f.touched.traffic_date && (
								<div className="form__message">{f.errors.traffic_date}</div>
							)}
							<DateField
								name="traffic_date"
								className="form__textarea"
								value={f.values.traffic_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.traffic_date}
								error={f.errors.traffic_date}
								blockFuture={true}
							/>
						</li>
						<li className={fieldStatus("prospect_count", f)}>
							<label htmlFor="prospect_count">
								Prospect Traffic<sup>*</sup>
							</label>
							{f.errors.prospect_count && f.touched.prospect_count && (
								<div className="form__message">{f.errors.prospect_count}</div>
							)}
							<NumberField
								name="prospect_count"
								type="text"
								className="form__input"
								onChange={(k, v) => {
									f.setFieldValue(`prospect_count`, v)
								}}
								onBlur={f.setFieldTouched}
								touched={f.touched.length > 0 && f.touched.prospect_count}
								error={f.errors.prospect_count}
								value={f.values.prospect_count}
								numeric={true}
							/>
						</li>
						<li className={fieldStatus("realtor_count", f)}>
							<label htmlFor="realtor_count">
								Realtor Traffic<sup>*</sup>
							</label>
							{f.errors.realtor_count && f.touched.realtor_count && (
								<div className="form__message">{f.errors.realtor_count}</div>
							)}
							<NumberField
								name="realtor_count"
								type="text"
								className="form__input"
								onChange={(k, v) => {
									f.setFieldValue(`realtor_count`, v)
								}}
								onBlur={f.setFieldTouched}
								touched={f.touched.length > 0 && f.touched.realtor_count}
								error={f.errors.realtor_count}
								value={f.values.realtor_count}
								numeric={true}
							/>
						</li>
						{settings.enabled && settings.enabled.infoCenterSplit && (
							<li className={`form__subrow ${fieldStatus("source", f)}`}>
								<label htmlFor="source">Traffic Source</label>
								{f.errors.source && f.touched.source && (
									<div className="form__message">{f.errors.source}</div>
								)}
								<ReactSelect
									name={`source`}
									options={this.sourceOptions()}
									value={f.values.source}
									onBlur={f.setFieldTouched}
									onChange={f.setFieldValue}
								/>
							</li>
						)}
					</ul>
					<input type="submit" value="Submit" className={helpers.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	eventLayout = (f) => {
		return (
			<div>
				<Form>
					<ul className="modalForm__list">
						<li className={fieldStatus("traffic_date", f)}>
							<label htmlFor="traffic_date">
								Traffic Date <sup>*</sup>
							</label>
							{f.errors.traffic_date && f.touched.traffic_date && (
								<div className="form__message">{f.errors.traffic_date}</div>
							)}
							<DateField
								name="traffic_date"
								className="form__textarea"
								value={f.values.traffic_date}
								onChange={f.setFieldValue}
								onBlur={f.setFieldTouched}
								touched={f.touched.traffic_date}
								error={f.errors.traffic_date}
								blockFuture={true}
							/>
						</li>
						<li className={fieldStatus("prospect_count", f)}>
							<label htmlFor="prospect_count">
								Prospect Traffic<sup>*</sup>
							</label>
							{f.errors.prospect_count && f.touched.prospect_count && (
								<div className="form__message">{f.errors.prospect_count}</div>
							)}
							<NumberField
								name="prospect_count"
								type="text"
								className="form__input"
								onChange={(k, v) => {
									f.setFieldValue(`prospect_count`, v)
								}}
								onBlur={f.setFieldTouched}
								touched={f.touched.length > 0 && f.touched.prospect_count}
								error={f.errors.prospect_count}
								value={f.values.prospect_count}
								numeric={true}
							/>
						</li>
						<li className={fieldStatus("realtor_count", f)}>
							<label htmlFor="realtor_count">
								Realtor Traffic<sup>*</sup>
							</label>
							{f.errors.realtor_count && f.touched.realtor_count && (
								<div className="form__message">{f.errors.realtor_count}</div>
							)}
							<NumberField
								name="realtor_count"
								type="text"
								className="form__input"
								onChange={(k, v) => {
									f.setFieldValue(`realtor_count`, v)
								}}
								onBlur={f.setFieldTouched}
								touched={f.touched.length > 0 && f.touched.realtor_count}
								error={f.errors.realtor_count}
								value={f.values.realtor_count}
								numeric={true}
							/>
						</li>
						<li className={fieldStatus("description", f)}>
							<label htmlFor="description">Event</label>
							{f.errors.description && f.touched.description && (
								<div className="form__message">{f.errors.description}</div>
							)}
							<Field
								onBlur={() => f.setFieldTouched(`description`)}
								name={`description`}
								type="text"
								className="form__input"
							/>
						</li>
						{settings.enabled && settings.enabled.infoCenterSplit && (
							<li className={`form__subrow ${fieldStatus("source", f)}`}>
								<label htmlFor="source">Traffic Source</label>
								{f.errors.source && f.touched.source && (
									<div className="form__message">{f.errors.source}</div>
								)}
								<ReactSelect
									name={`source`}
									options={this.sourceOptions()}
									value={f.values.source}
									onBlur={f.setFieldTouched}
									onChange={f.setFieldValue}
								/>
							</li>
						)}
					</ul>
					<input type="submit" value="Submit" className={helpers.submitClasses(f.isValid)} />
				</Form>
			</div>
		)
	}

	realtorFields = (f, i) => {
		if (f.values.is_realtor == 1) {
			return (
				<>
					<li className={fieldStatus("realtor", f)}>
						<label htmlFor="realtor">
							Realtor License Number<sup>*</sup>
						</label>
						{f.errors.realtor && f.touched.realtor && (
							<div className="form__message">{f.errors.realtor}</div>
						)}
						<NumberField
							name="realtor"
							type="text"
							className="form__input"
							onChange={(k, v) => {
								f.setFieldValue(`realtor`, v)
							}}
							onBlur={f.setFieldTouched}
							touched={f.touched.length > 0 && f.touched.realtor}
							error={f.errors.realtor}
							value={f.values.realtor}
						/>
					</li>
					<li className={fieldStatus("realtor_regions", f)}>
						<label htmlFor="realtor_regions">Realtor Regions</label>
						{f.errors.realtor_regions && f.touched.realtor_regions && (
							<div className="form__message">{f.errors.realtor_regions}</div>
						)}
						<ReactSelect
							name={`realtor_regions`}
							options={_.map(this.props.payload.public.options.realtor_regions, (v) => {
								return { label: v.name, value: v.id }
							})}
							isMulti
							value={f.values.realtor_regions}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
				</>
			)
		}
	}

	withRealtorFields = (f, i) => {
		if (f.values.is_realtor == 0) {
			return (
				<>
					<li className={fieldStatus("realtor", f)}>
						<label htmlFor="realtor">Accompanying Realtor License Number</label>
						{f.errors.realtor && f.touched.realtor && (
							<div className="form__message">{f.errors.realtor}</div>
						)}
						<NumberField
							name="realtor"
							type="text"
							className="form__input"
							onChange={(k, v) => {
								f.setFieldValue(`realtor`, v)
							}}
							onBlur={f.setFieldTouched}
							touched={f.touched.length > 0 && f.touched.realtor}
							error={f.errors.realtor}
							value={f.values.realtor}
						/>
					</li>
				</>
			)
		}
	}

	checkNo = (f, e, type, field) => {
		let no = "Unknown"
		if (field == "email") {
			no = settings.noEmailAddress
		}
		if (e.target.checked) {
			f.setFieldValue(field, no)
			f.setFieldValue(type, true)
		} else {
			f.setFieldValue(field, "")
			f.setFieldValue(type, false)
		}
		f.validateForm()
	}

	infoUsers = () => {
		let ret = []
		_.forEach(this.props.payload.public.info_center_users, (v) => {
			if (v.property == this.props.activeProperties[0] && v.status === 1) {
				ret.push({ label: `${v.first} ${v.last}`, value: v.id })
			}
		})
		return ret
	}

	detailedLayout = (f) => {
		//console.log(f)
		let addl = _.get(settings, "additionalTrafficFields") || []
		let states = this.props.payload.public.states
		return (
			<Form>
				<ul className="form__subList form__subList--noBorder">
					<li className={`form__subrow ${fieldStatus("traffic_date", f)}`}>
						<label htmlFor="traffic_date">
							Traffic Date <sup>*</sup>
						</label>
						{f.errors.length > 0 && f.errors.traffic_date && f.touched.traffic_date && (
							<div className="form__message">{f.errors.traffic_date}</div>
						)}
						<DateField
							name="traffic_date"
							className="form__textarea"
							value={f.values.traffic_date}
							onChange={(k, v) => f.setFieldValue(`traffic_date`, v)}
							onBlur={() => f.setFieldTouched(`traffic_date`, true)}
							blockFuture={true}
						/>
					</li>
					<li className={`form__subrow ${fieldStatus("source", f)}`}>
						<label htmlFor="source">Traffic Source</label>
						{f.errors.source && f.touched.source && <div className="form__message">{f.errors.source}</div>}
						<ReactSelect
							name={`source`}
							options={transformOptionsObject(this.props.payload.public.trafficSources)}
							value={f.values.source}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
					<li className={fieldStatus("first_name", f)}>
						<label htmlFor="first_name">
							First Name <sup>*</sup>
						</label>
						<div className="noEmail">
							<Field
								type="checkbox"
								name={`no_first`}
								onChange={(e) => this.checkNo(f, e, "no_first", "first_name")}
							/>
							No First Name
						</div>
						{f.errors.first_name && f.touched.first_name && (
							<div className="form__message">{f.errors.first_name}</div>
						)}
						<Field
							onBlur={() => f.setFieldTouched(`first_name`)}
							name={`first_name`}
							type="text"
							className="form__input"
						/>
					</li>
					<li className={fieldStatus("last_name", f)}>
						<label htmlFor="last_name">
							Last Name <sup>*</sup>
						</label>
						<div className="noEmail">
							<Field
								type="checkbox"
								name={`no_last`}
								onChange={(e) => this.checkNo(f, e, "no_last", "last_name")}
							/>
							No Last Name
						</div>
						{f.errors.last_name && f.touched.last_name && (
							<div className="form__message">{f.errors.last_name}</div>
						)}
						<Field
							onBlur={() => f.setFieldTouched(`last_name`)}
							name={`last_name`}
							type="text"
							className="form__input"
						/>
					</li>
					<li className={fieldStatus("zip", f)}>
						<label htmlFor="zip">Zip</label>
						{f.errors.zip && f.touched.zip && <div className="form__message">{f.errors.zip}</div>}
						<Field
							onBlur={() => f.setFieldTouched(`zip`)}
							name={`zip`}
							type="text"
							className="form__input"
						/>
					</li>
					<li className={fieldStatus("email", f)}>
						<label htmlFor="email">
							Email <sup>*</sup>
						</label>
						<div className="noEmail">
							<Field
								type="checkbox"
								name={`no_email`}
								onChange={(e) => this.checkNo(f, e, "no_email", "email")}
							/>
							No Email
						</div>
						{f.errors.email && f.touched.email && <div className="form__message">{f.errors.email}</div>}
						<Field name={`email`} type="email" className="form__input" />
					</li>
					<li className={fieldStatus("phone", f)}>
						<label htmlFor="phone">Phone</label>
						{f.errors.phone && f.touched.phone && <div className="form__message">{f.errors.phone}</div>}
						<NumberField
							name={`phone`}
							value={f.values.phone}
							format="+1 (###) ###-####"
							className="form__input"
							isNumericString
							onChange={(name, v) => {
								f.setFieldValue(`phone`, v)
							}}
							onBlur={() => f.setFieldTouched("phone", true)}
						/>
					</li>
					<li className={`form__subrow ${fieldStatus("want_contact", f)}`}>
						<label htmlFor="want_contact">
							Subscribe to Newsletter? <sup>*</sup>
						</label>
						{f.errors.want_contact && f.touched.want_contact && (
							<div className="form__message">{f.errors.want_contact}</div>
						)}
						<ReactSelect
							name={`want_contact`}
							options={[
								{ value: 1, label: "Yes" },
								{ value: 0, label: "No" },
							]}
							value={f.values.want_contact}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
					<li className={`form__subrow ${fieldStatus("is_realtor", f)}`}>
						<label htmlFor="is_realtor">
							Is this person a Realtor? <sup>*</sup>
						</label>
						{f.errors.is_realtor && f.touched.is_realtor && (
							<div className="form__message">{f.errors.is_realtor}</div>
						)}
						<ReactSelect
							name={`is_realtor`}
							options={[
								{ value: 0, label: "No" },
								{ value: 1, label: "Yes" },
							]}
							value={f.values.is_realtor}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
					<li className={`form__subrow ${fieldStatus("host", f)}`}>
						<label htmlFor="host">Host</label>
						{f.errors.host && f.touched.host && <div className="form__message">{f.errors.host}</div>}
						<ReactSelect
							name={`host`}
							options={this.infoUsers()}
							value={f.values.host}
							onBlur={f.setFieldTouched}
							onChange={f.setFieldValue}
						/>
					</li>
					<li className={fieldStatus("notes", f)}>
						<label htmlFor="notes">Notes</label>
						{f.errors.notes && f.touched.notes && <div className="form__notes">{f.errors.notes}</div>}
						<TextArea
							name="notes"
							className="form__textarea"
							value={f.values.notes}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.notes}
							error={f.errors.notes}
						/>
					</li>
					{this.realtorFields(f)}
					{this.withRealtorFields(f)}
					{_.find(addl, { type: "street" }) ? (
						<li className={fieldStatus("street", f)}>
							<label htmlFor="street">Address</label>
							{f.errors.length > 0 && f.errors.street && f.touched.street && (
								<div className="form__message">{f.errors.street}</div>
							)}
							<Field
								onBlur={() => f.setFieldTouched(`street`, true)}
								name={`street`}
								type="text"
								className="form__input"
							/>
						</li>
					) : null}
					{_.find(addl, { type: "city" }) ? (
						<li className={fieldStatus("city", f)}>
							<label htmlFor="city">City</label>
							{f.errors.length > 0 && f.errors.city && f.touched.city && (
								<div className="form__message">{f.errors.city}</div>
							)}
							<Field
								onBlur={() => f.setFieldTouched(`city`, true)}
								name={`city`}
								type="text"
								className="form__input"
							/>
						</li>
					) : null}
					{_.find(addl, { type: "state" }) ? (
						<li className={fieldStatus("state", f)}>
							<label htmlFor="state">State</label>
							{f.errors.length > 0 && f.errors.state && f.touched.state && (
								<div className="form__message">{f.errors.state}</div>
							)}
							<ReactSelect
								name={`state`}
								options={states}
								value={f.values.state}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
					) : null}
					{_.find(addl, { type: "zip" }) ? (
						<li className={fieldStatus("zip", f)}>
							<label htmlFor="zip">Zip</label>
							{f.errors.length > 0 && f.errors.zip && f.touched.zip && (
								<div className="form__message">{f.errors.zip}</div>
							)}
							<Field
								onBlur={() => f.setFieldTouched(`zip`, true)}
								name={`zip`}
								type="text"
								className="form__input"
							/>
						</li>
					) : null}
					{_.find(addl, { type: "how_much" }) ? (
						<li className={fieldStatus("how_much", f)}>
							<label htmlFor="how_much">Price Range</label>
							{f.errors.length > 0 && f.errors.how_much && f.touched.how_much && (
								<div className="form__message">{f.errors.how_much}</div>
							)}
							<ReactSelect
								name={`how_much`}
								options={_.find(addl, { type: "how_much" }).options.map((v) => {
									return { value: v, label: v }
								})}
								value={f.values.how_much}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
					) : null}
					{_.find(addl, { type: "timeframe" }) ? (
						<li className={fieldStatus("timeframe", f)}>
							<label htmlFor="timeframe">Timeframe</label>
							{f.errors.length > 0 && f.errors.timeframe && f.touched.timeframe && (
								<div className="form__message">{f.errors.timeframe}</div>
							)}
							<ReactSelect
								name={`timeframe`}
								options={_.find(addl, { type: "timeframe" }).options.map((v) => {
									return { value: v, label: v }
								})}
								value={f.values.timeframe}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
					) : null}
					{_.find(addl, { type: "want_text" }) ? (
						<li className={fieldStatus("want_text", f, true)}>
							<label htmlFor="want_text">Subscribe To Text?</label>
							{f.errors.length > 0 && f.errors.want_text && f.touched.want_text && (
								<div className="form__message">{f.errors.want_text}</div>
							)}
							<ReactSelect
								name={`want_text`}
								options={_.find(addl, { type: "want_text" }).options.map((v) => {
									return { value: v.value, label: v.label }
								})}
								value={f.values.want_text}
								onBlur={f.setFieldTouched}
								onChange={f.setFieldValue}
							/>
						</li>
					) : null}
				</ul>
				<input type="submit" value="Submit" className={helpers.submitClasses(f.isValid)} />
			</Form>
		)
	}

	webLeads = (f) => {
		console.log(f)
		return (
			<Form>
				<ul className="form__subList form__subList--noBorder">
					<li className={fieldStatus("date", f)}>
						<label htmlFor="date">
							Date <sup>*</sup>
						</label>
						{f.errors.length > 0 && f.errors.date && f.touched.date && (
							<div className="form__message">{f.errors.date}</div>
						)}
						<DateField
							name="date"
							className="form__textarea"
							value={f.values.date}
							onChange={(k, v) => f.setFieldValue(`date`, v)}
							onBlur={() => f.setFieldTouched(`date`, true)}
							blockFuture={true}
						/>
					</li>
					<li className={fieldStatus("first_name", f)}>
						<label htmlFor="first_name">
							First Name <sup>*</sup>
						</label>
						<div className="noEmail">
							<Field
								type="checkbox"
								name={`no_first`}
								onChange={(e) => this.checkNo(f, e, "no_first", "first_name")}
							/>
							No First Name
						</div>
						{f.errors.first_name && f.touched.first_name && (
							<div className="form__message">{f.errors.first_name}</div>
						)}
						<Field
							onBlur={() => f.setFieldTouched(`first_name`)}
							name={`first_name`}
							type="text"
							className="form__input"
						/>
					</li>
					<li className={fieldStatus("last_name", f)}>
						<label htmlFor="last_name">
							Last Name <sup>*</sup>
						</label>
						<div className="noEmail">
							<Field
								type="checkbox"
								name={`no_last`}
								onChange={(e) => this.checkNo(f, e, "no_last", "last_name")}
							/>
							No Last Name
						</div>
						{f.errors.last_name && f.touched.last_name && (
							<div className="form__message">{f.errors.last_name}</div>
						)}
						<Field
							onBlur={() => f.setFieldTouched(`last_name`)}
							name={`last_name`}
							type="text"
							className="form__input"
						/>
					</li>
					<li className={fieldStatus("email", f)}>
						<label htmlFor="email">
							Email <sup>*</sup>
						</label>
						<div className="noEmail">
							<Field
								type="checkbox"
								name={`no_email`}
								onChange={(e) => this.checkNo(f, e, "no_email", "email")}
							/>
							No Email
						</div>
						{f.errors.email && f.touched.email && <div className="form__message">{f.errors.email}</div>}
						<Field name={`email`} type="email" className="form__input" />
					</li>
					<li className={fieldStatus("phone", f)}>
						<label htmlFor="phone">Phone</label>
						{f.errors.phone && f.touched.phone && <div className="form__message">{f.errors.phone}</div>}
						<NumberField
							name={"phone"}
							value={f.values.phone}
							format="+1 (###) ###-####"
							type="text"
							className="form__input"
							onChange={(old, v) => f.setFieldValue("phone", v)}
							onBlur={() => {}}
						/>
					</li>
					<li className={fieldStatus("zip", f)}>
						<label htmlFor="zip">Zip</label>
						{f.errors.zip && f.touched.zip && <div className="form__message">{f.errors.zip}</div>}
						<Field name="zip" type="text" className="form__input" />
					</li>
					<li className={fieldStatus("message", f)}>
						<label htmlFor="message">Comments</label>
						{f.errors.message && f.touched.message && (
							<div className="form__message">{f.errors.message}</div>
						)}
						<TextArea
							name="message"
							className="form__textarea"
							value={f.values.message}
							onChange={f.setFieldValue}
							onBlur={f.setFieldTouched}
							touched={f.touched.message}
							error={f.errors.message}
						/>
					</li>
				</ul>
				<input type="submit" value="Submit" className={helpers.submitClasses(f.isValid)} />
			</Form>
		)
	}

	textingButton = () => {
		if (this.props.activeProperties.length !== 1) return ""
		let property = _.find(this.props.payload.public.properties, (r) => r.id == this.props.activeProperties[0])
		if (!property || !property?.copilot) return
		return (
			<div className="mb-8">
				<span className="btn btn--row" onClick={() => this.setState({ texting: true })}>
					Text Walk-in Prospect
				</span>
			</div>
		)
	}

	textingModule = () => {
		if (this.props.activeProperties.length !== 1) return ""
		let property = _.find(this.props.payload.public.properties, (r) => r.id == this.props.activeProperties[0])
		if (!property) return
		if (property.copilot) {
			return <CoPilotTexting welcomeCenter={true} property={this.props.activeProperties[0]} />
		}
		return ""
	}

	render() {
		if (this.props.activeProperties.length !== 1) {
			return (
				<div className="pleaseChoose">
					<h1>Please choose one community to enter traffic.</h1>
				</div>
			)
		} else if (this.props.payloadStatus) {
			return (
				<div className="infoCenter">
					<div className="imageGroup">
						<Title title="Info Center Traffic Entry" />
						<div className="content">
							{this.textingButton()}
							<div className="reportGroup">
								<h3>Regular Traffic</h3>
								<Formik
									initialValues={this.state.fields}
									validationSchema={this.regularValidation}
									enableReinitialize
									validateOnMount={true}
									onSubmit={(values, actions) => {
										//values.id = this.props.data.id
										values.property = this.props.activeProperties[0]
										submitData("inputWelcomeGrouped", values)
											.then((data) => {
												toast.success(data.message)
												actions.resetForm()
												actions.validateForm()
											})
											.catch((e) => {
												toast.error(
													"Error inputting grouped traffic.  If the problem persists, please contact support."
												)
											})
									}}
									render={(f) => this.regularLayout(f)}
								/>
							</div>
							<div className="reportGroup">
								<h3>Event Traffic</h3>
								<Formik
									initialValues={this.state.eventField}
									validationSchema={this.eventValidation}
									enableReinitialize
									validateOnMount={true}
									onSubmit={(values, actions) => {
										//values.id = this.props.data.id
										values.property = this.props.activeProperties[0]
										//return

										submitData("inputWelcomeEvent", values)
											.then((data) => {
												toast.success(data.message)
												actions.resetForm()
												actions.validateForm()
											})
											.catch((e) => {
												toast.error(
													"Error inputting event traffic.  If the problem persists, please contact support."
												)
											})
									}}
									render={(f) => this.eventLayout(f)}
								/>
							</div>
							<div className="reportGroup">
								<h3>Detailed Traffic</h3>
								<Formik
									initialValues={this.state.detailedFields}
									validationSchema={this.detailedValidation}
									enableReinitialize
									validateOnMount={true}
									onSubmit={(values, actions) => {
										delete values.no_first
										delete values.no_last
										delete values.no_email
										values.property = this.props.activeProperties[0]
										values.salesperson = this.user?.id // tracks who was logged in when logging this.  used for monaca/jdc with realtor tracking
										submitData("inputWelcomeDetailed", values)
											.then((data) => {
												toast.success(data.message)
												actions.resetForm()
												actions.validateForm()
											})
											.catch((e) => {
												toast.error(
													"Error inputting grouped traffic.  If the problem persists, please contact support."
												)
											})
									}}
									render={(f) => this.detailedLayout(f)}
								/>
							</div>
							{settings?.enabled?.infoCenterLeads ? (
								<div className="reportGroup">
									<h3>Leads</h3>
									<Formik
										initialValues={this.state.webLeadFields}
										validationSchema={this.webLeadsValidation}
										enableReinitialize
										validateOnMount={true}
										onSubmit={(values, actions) => {
											values.property = this.props.activeProperties[0]
											values.action = "inputWelcomeLead"
											submitData("mainIngest", values)
												.then((data) => {
													toast.success(data.message)
													actions.resetForm()
													actions.validateForm()
												})
												.catch((e) => {
													toast.error(
														"Error inputting grouped traffic.  If the problem persists, please contact support."
													)
												})
										}}
										render={(f) => this.webLeads(f)}
									/>
								</div>
							) : null}
							<Modal
								classNames={{ modal: "modalForm" }}
								open={this.state.texting}
								onClose={() => this.setState({ texting: false })}
								center>
								{this.textingModule()}
							</Modal>
						</div>
					</div>
				</div>
			)
		} else {
			return ""
		}
	}
}

function mapStateToProps(state) {
	return {
		currentDates: state.currentDates,
		compareDates: state.compareDates,
		payload: state.payload,
		payloadStatus: state.payloadStatus,
		activeProperties: state.activeProperties,
	}
}

function matchDispatchToProps(dispatch) {
	return bindActionCreators({}, dispatch)
}

export default connect(mapStateToProps, matchDispatchToProps)(InfoCenter)
